import React from 'react';
import { Button, Typography, Stack } from '@mui/material';
import { useAuth } from '../../../contexts/AuthContext';
import { phonePrint } from '@pv/common/utils';
import { UserAvatar } from '../../../components/UserAvatar';

export const GuestInfo = () => {
  const { guest, signOut } = useAuth();

  if (!guest) {
    return null;
  }

  const { fullName, email, phone, gravatarUrl } = guest;
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      sx={{
        flexShrink: 1,
        minWidth: 0,
        width: '100%',
      }}
    >
      <UserAvatar fullName={fullName} gravatarUrl={gravatarUrl} />
      <Stack sx={{ minWidth: 0, flex: 1 }}>
        <Typography noWrap variant="subtitle1">
          {fullName}
        </Typography>
        <Typography
          variant="body2"
          noWrap
          sx={{
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {email}
        </Typography>

        <Typography variant="body2">{phonePrint(phone)}</Typography>
      </Stack>
      <Button variant="text" size="small" onClick={signOut}>
        Not You?
      </Button>
    </Stack>
  );
};
